/**
 * Получение заголовков авторизации для Edge Function запросов.
 * Использует Supabase сессию для получения JWT токена.
 * Если пользователь не авторизован — использует anon ключ.
 */

import { supabase } from '../../../shared/api/supabase-client';

const REFRESH_MARGIN_S = 60;

export async function getAuthHeaders(): Promise<Record<string, string>> {
  let {
    data: { session },
  } = await supabase.auth.getSession();

  if (session) {
    const expiresAt = session.expires_at ?? 0;
    const nowSec = Math.floor(Date.now() / 1000);

    if (expiresAt - nowSec < REFRESH_MARGIN_S) {
      const { data, error } = await supabase.auth.refreshSession();
      if (!error && data.session) {
        session = data.session;
      }
    }

    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    };
  }

  // Fallback: используем anon ключ
  const { publicAnonKey } = await import('../../../utils/supabase/info');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${publicAnonKey}`,
  };
}
